const { linkResolver } = require("./linkResolver")
const { componentResolver } = require("./prismicComponentResolver")

const REPOSITORY_NAME = process.env.GATSBY_PRISMIC_REPO_NAME || "alpacked"

const repositoryConfigs = [
  {
    repositoryName: REPOSITORY_NAME,
    linkResolver: doc => linkResolver(doc),
    componentResolver,
    previewPath: "/preview",
  },
]

module.exports = {
  repositoryConfigs,
  repositoryName: REPOSITORY_NAME,
  componentResolver,
  linkResolver,
  REPOSITORY_NAME,
  default: repositoryConfigs,
}
